import create from 'zustand';

export const useEditorStore = create((set) => ({
  // File state
  uploadedFile: null,
  uploadedFilename: null,
  backendFilename: null,
  sessionId: null,

  // Model state
  originalModelUrl: null,
  editedModelUrl: null,
  isModelLoaded: false,

  // UI state
  loading: false,
  error: null,
  successMessage: null,

  // Editing state
  prompt: '',
  actions: [],

  // Actions
  setUploadedFile: (file, filename, sessionId) =>
    set({ uploadedFile: file, uploadedFilename: filename, backendFilename: filename, sessionId }),

  setModelUrl: (url, isEdited = false) =>
    set((state) => {
      if (isEdited) {
        return { editedModelUrl: url, isModelLoaded: true };
      }
      return { originalModelUrl: url, isModelLoaded: true };
    }),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),

  setSuccess: (message) => set({ successMessage: message }),

  setPrompt: (prompt) => set({ prompt }),

  setActions: (actions) => set({ actions }),

  clearError: () => set({ error: null }),

  clearSuccess: () => set({ successMessage: null }),

  reset: () =>
    set({
      uploadedFile: null,
      uploadedFilename: null,
      backendFilename: null,
      sessionId: null,
      originalModelUrl: null,
      editedModelUrl: null,
      isModelLoaded: false,
      loading: false,
      error: null,
      successMessage: null,
      prompt: '',
      actions: [],
    }),
}));
